export default {
  "form": {
    "select": {
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please select"])}
    },
    "input": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piece"])}
    }
  },
  "buttons": {
    "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download assembly instructions"])},
    "watchlistAdd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add to watchlist"])},
    "watchlistAdded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Added to watchlist"])},
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Request now"])}
  },
  "labels": {
    "modelFilter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thread, pipe dimension"])},
    "model": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Model"])},
    "productGroup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product group"])},
    "articleNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Article number"])},
    "technicalNote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technical note"])}
  },
  "error": {
    "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have to make a selection!"])}
  }
}